module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isManager('project|finance|maintenance|admin|management')) ? _c('popup', {
    attrs: {
      "button-style": "info",
      "heading": "Progress Workflow",
      "show-text": _vm.showText,
      "button-size": _vm.buttonSize,
      "button-text": "Add Progress",
      "button-icon": "fa fa-cogs",
      "disable-save": false,
      "disable-button": !_vm.isManager('project|finance|maintenance|admin|management') || _vm.readOnly
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('Progress-detail', {
    ref: "PRG",
    attrs: {
      "owner-id": _vm.ownerId,
      "site-id": _vm.siteId,
      "editMode": true,
      "adding": true,
      "hide-panel": true
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aed8136c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/ProgressAction.vue
// module id = 1614
// module chunks = 0